const YearNavButton = ({ label, colors, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    style={{
      width: "32px",
      height: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "18px",
      lineHeight: 1,
      cursor: "pointer",
      color: colors.text,
      backgroundColor: "transparent",
      border: `1px solid ${colors.border}`,
      borderRadius: "6px",
    }}
  >
    {label}
  </button>
);

export default YearNavButton;
